import React from 'react';
import useEditorStore from '../../stores/useEditorStore';
import { useShallow } from 'zustand/shallow';
import { useToolManager } from '../../hooks/useToolManager';

const PencilToolCard = () => {
  const DEFAULT_BRUSH_SIZE = 1;
  const MIN_BRUSH_SIZE = 0.1;
  const MAX_BRUSH_SIZE = 3;

  const [pencilSize, setToolSetting] = useEditorStore(
    useShallow((state) => [
      state.toolSettings.scan_preparing_pencil?.size || DEFAULT_BRUSH_SIZE,
      state.setToolSetting
    ])
  );

  const { run } = useToolManager();

  const onFillButtonClick = () => {
    run({tool: 'scan_preparing_pencil', mode: 'fill'});
  }

  return (
    <div
  className="
    absolute top-[10px] left-[10px]
    bg-white/95
    rounded-lg p-4
    shadow-[0_2px_8px_rgba(0,0,0,0.1)]
    min-w-[200px]
    z-[1000]
  "
>
  {/* Controls wrapper */}
  <div className="mb-2">
    {/* Size slider + reset */}
    <div className="flex gap-3 items-center mt-2 mb-8">
      <input
        type="range"
        min={MIN_BRUSH_SIZE}
        max={MAX_BRUSH_SIZE}
        value={pencilSize}
        step={0.1}
        onChange={(e) =>
          setToolSetting(
            'scan_preparing_pencil',
            'size',
            parseFloat(e.target.value)
          )
        }
        className="
          w-full
          h-[6px]
          rounded-[3px]
          outline-none
          appearance-none
        "
        style={{
          background: `linear-gradient(
            to right,
            #7c3aed 0%,
            #7c3aed ${ (pencilSize / MAX_BRUSH_SIZE) * 100 }%,
            #e5e7eb ${ (pencilSize / MAX_BRUSH_SIZE) * 100 }%,
            #e5e7eb 100%
          )`,
        }}
      />
      <div className='text-black text-sm w-8 text-center'>{pencilSize}</div>
      <img
        src="/tool_icons/scan_preparing_pencil.png"
        alt="Reset"
        onClick={() =>
          setToolSetting('scan_preparing_pencil', 'size', DEFAULT_BRUSH_SIZE)
        }
        className="w-4 h-4 cursor-pointer opacity-100"
      />
    </div>

    {/* Fill button */}
    <button
      onClick={onFillButtonClick}
      className="
        w-full
        px-4 py-3
        bg-purple-600 hover:bg-purple-700
        text-white
        border-0
        rounded-md
        text-sm font-semibold
        cursor-pointer
        transition-colors duration-200
      "
    >
      Fill
    </button>
  </div>
</div>

  );
};

export default PencilToolCard; 